const dealersData = {
  dealers: [
    { label: "Armstrong's Peugeot Auckland", code: 'APGLN' },
    { label: 'North Shore Peugeot', code: 'APNTS' },
    { label: "Armstrong's Peugeot East Auckland", code: 'APEAK' },
    { label: 'Southern Autos Manukau Peugeot', code: 'ASAMK' },
    { label: 'Duncan & Ebbett Peugeot', code: 'DEPHN' },
    { label: 'Shorland Peugeot Tauranga', code: 'SPTGA' },
    { label: 'Shorland Peugeot Rotorua', code: 'APROT' },
    { label: 'Hawkes Bay Peugeot', code: 'APHKB' },
    { label: "Armstrong's Peugeot Christchurch", code: 'APCHC' },
    { label: 'Southern Motor Court Dunedin', code: 'ASMCD' },
    { label: "Armstrong's Peugeot Lower Hutt", code: 'APWLT' },
    { label: 'Eurocar Peugeot', code: 'AEPPM' },
    { label: 'Peugeot Whanganui', code: 'APWHG' }
  ]
}

export default dealersData
